import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';

@Component({
  selector: 'listo-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent implements OnInit {
  authenticated = this.auth.isAuthenticated;

  constructor(private auth: AuthService) {}

  ngOnInit() {
    this.auth.authChanges.subscribe(authenticated => {
      this.authenticated = authenticated;
    });
  }
}
